import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import FloatingAlert from "../../../components/FloatingAlert/FloatingAlert";
import bgSliders from "../../../helpers/bgSliders";
import "./SignupPage.styled";
import GamezoneOnlineSignupPageDisplay from "./SignupPage.styled";
import { setLoginData } from "../../../helpers/helpers";
import { Trans, withTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { setAgencyData, saveTracker } from "../../../helpers/agencyTracker";
import queryString from "query-string";



const randomBg = bgSliders.getRandomBg();
function GamezoneOnlineSignupPage({ t }) {
  const [activeData, setActiveData] = useState("");
  const [checkPhone, setCheckPhone] = useState(false);

  const [showverif, setShowverif] = useState(false);
  const [verifyCode, setVerifyCode] = useState(false);
  const [errorMesg, setErrorMesg] = useState(false);
  const [verfiErrorMesg, setVerfiErrorMesg] = useState(false);
  const [errorresverify, seterrorresverify] = useState("");

  const [errorMesgSubscribe, setErrorMesgSubscribe] = useState("");
  const [signupPlan, setSignupPlan] = useState("d");
  const [otpid, setotpid] = useState("");
  const [showLoading, setshowLoading] = useState(false);
  const [transactionidentify,setTransactionidentify] = useState("");
  const [transactionid,setTransactionid] = useState("");


  const history = useHistory();
  const [alert, setAlert] = useState(false);
  const params = queryString.parse(window.location.search);
  const [btn, setbtn] = useState(false);



 
  useEffect(() => {
  redirect();
   
  }, []);

 
  const redirect = async () => {
    try {
      const res = await axios.post(`http://vas2.grand-hub.com/api/PlayIt/ooredoo-om-d/he ` ,{});
     
       if (res.data.success == true) {
      //   console.log(res.data.url);
        window.location.href = res.data.url;
       }
       else {
         setErrorMesg(true);
         setErrorMesgSubscribe(res.data.msg)
         
       }

       setshowLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
 
 
 






  return (
    <GamezoneOnlineSignupPageDisplay className="">
    
      

    </GamezoneOnlineSignupPageDisplay>
  );
}
export default withTranslation()(GamezoneOnlineSignupPage)
